import React from 'react';
import {HashRouter, Route, Routes} from "react-router-dom";
import './assets/App.scss';
import '../node_modules/bulma/css/bulma.css'
import Menu from './screen/Menu/menu.component'
import DetailMenu from './screen/DetailMenu/detailmenu.component'
import Cart from './screen/Cart/cart.component'
import Tenant from './screen/Tenant/tenant.component';
import RiwayatTransaksi from './screen/RiwayatTransaksi/riwayatTransaksi.component';
import VoucherList from './screen/VoucherList/voucherlist.component';
import VoucherDetail from './screen/VoucherDetail/voucherdetail.component';
import RincianTransaksi from './screen/RincianTransaksi/rincianTransaksi.component';
import TopUp from './screen/Topup/topup.component';
import Result from './screen/Result/result.component';

import axios from "axios";

function App() {
    return (
        <HashRouter hashType={"slash"}>
            <Routes>
                <Route index path="/home" element={<Tenant/>}/>
                <Route path="/menu" element={<Menu/>}/>
                <Route path="/detail" element={<DetailMenu/>}/>
                <Route path="/payment" element={<Cart/>}/>
                <Route path="/transaction" element={<RiwayatTransaksi/>}/>
                <Route path="/detail-transaction" element={<RincianTransaksi/>}/>
                <Route path="/voucher-list" element={<VoucherList/>}/>
                <Route path="/voucher-detail" element={<VoucherDetail/>}/>
                <Route path="/topup" element={<TopUp/>}/>
                <Route path="/result" element={<Result/>}/>
            </Routes>
        </HashRouter>
    );
}

export default App;
